import React from 'react';
import useNextStepVm from '|/app/purchase/flow/next-step/use-next-step-vm';
import { Dashboard, Summary } from '|/app/services';

const defaultProps = {
  setDashboard: (_: Dashboard) => {
    /* intentionally left blank */
  },
  setSummary: (_: Summary) => {
    /* intentionally left blank */
  }
};

const NextStep = ({ setDashboard, setSummary } = defaultProps) => {
  useNextStepVm(setDashboard, setSummary);
  return <></>;
};

export default NextStep;
